<template>
  <div class="userheder">
    <el-form
      :inline="true"
      :model="formSearch"
      ref="formSearch"
      class="demo-form-inline"
    >
      <!-- <el-col class="date"> -->
      <el-form-item label="日期">
        <el-date-picker
          v-model="formSearch.formdate"
          type="daterange"
          size="small"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </el-form-item>
      <!-- </el-col>
        <el-col> -->
      <el-form-item label="产品">
        <product-select
          :value.sync="formSearch.afid"
          :multiple="true"
          class="all-select"
          placeholder="全部"
          popper-class="BI-select BI-select-product report_select"
        >
        </product-select>
      </el-form-item>
      <el-form-item label="地区">
        <areaMultiSelect
          :value.sync="formSearch.geo"
          :optionsList="countryList"
        >
        </areaMultiSelect>
      </el-form-item>
      <el-form-item label="平台">
        <el-select v-model="formSearch.osType" placeholder="全部">
          <el-option label="全部" :value="null"></el-option>
          <el-option label="android" value="android"></el-option>
          <el-option label="google" value="google"></el-option>
          <el-option label="ios" value="ios"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleReset">重置 </el-button>
        <el-button type="primary" @click="handleSearch">查询 </el-button>
        <el-tooltip
          class="item"
          effect="dark"
          content="下载excel"
          placement="top"
        >
          <i
            v-loading="downloadLoading"
            class="el-icon-download"
            style="font-size: 20px; cursor: pointer; margin-left: 10px"
            @click="downloadFile"
          />
        </el-tooltip>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { changeshortcutclass, clearallshortcutclass } from "@/utils/tool";
import moment from "moment";
import { getOriginCountryListFetch } from "@/api/api.js";
import areaMultiSelect from "@/components/areaMultiSelect.vue";
export default {
  components: {
    areaMultiSelect,
  },
  computed: {},
  mounted: function () {
    getOriginCountryListFetch().then((result) => {
      if (result.code == "0000") {
        this.countryList = result.countryList;
        let param = {
          dateStart: moment(this.formSearch.formdate[0]).format("YYYYMMDD"),
          dateEnd: moment(this.formSearch.formdate[1]).format("YYYYMMDD"),
          afid: this.formSearch.afid.length
            ? this.formSearch.afid.join()
            : null,
          isisRate: true,
          geo: this.formSearch.geo.join(","),
          osType: this.formSearch.osType,
          type: 2,
        };
        this.$emit("handleSearch", param);
      }
    });
  },
  data() {
    return {
      countryList: [],
      checked: false,
      formSearch: {
        formdate: [
          new Date(new Date().getTime() - 3600 * 1000 * 24 * 6),
          new Date(),
        ],
        afid: [],
        osType: null,
        geo: [],
      },
      downloadLoading: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "当天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("当天", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一周", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一个月", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近2个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近2个月", picker.$el);
              }, 0);
            },
          },
        ],
        onPick: function ({ maxDate, minDate }) {
          clearallshortcutclass(this.$el);
          console.log(maxDate, minDate);
        },
        // disabledDate: function(time) {
        //   return time.getTime() > Date.now();
        // }
        disabledDate: function (date) {
          if (new Date().getTime() - date.getTime() > 0) {
            return false;
          }
          return true;
        },
      },
    };
  },
  methods: {
    handleReset() {
      this.formSearch = {
        formdate: [
          new Date(new Date().getTime() - 3600 * 1000 * 24 * 6),
          new Date(),
        ],
        afid: [],
        osType: null,
        geo: [],
      };
      this.handleSearch();
    },
    handleSearch() {
      let param = {
        dateStart: moment(this.formSearch.formdate[0]).format("YYYYMMDD"),
        dateEnd: moment(this.formSearch.formdate[1]).format("YYYYMMDD"),
        afid: this.formSearch.afid.length ? this.formSearch.afid.join() : null,
        isisRate: true,
        geo: this.formSearch.geo.join(","),
        osType: this.formSearch.osType,
        type: 2,
      };
      this.$emit("handleSearch", param);
    },
    closeDownLoadLoading() {
      this.downloadLoading = false;
    },
    downloadFile() {
      this.downloadLoading = true;
      this.$emit("downloadFile");
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@borderline: #e6e6e6;
.el-date-editor--daterange {
  width: 300px;
}
// .el-button {
//   margin-left: 186px;
// }
.userheder {
  padding: 10px;
  // border: 1px solid #e6e6e6;
  margin: 2px;
  border-radius: 3px;
  align-items: baseline;
  display: flex;
  min-width: 1200px;
}
.headerleft {
  text-align: right;
  i {
    font-size: 20px;
    margin-right: 10px;
    cursor: pointer;
  }
  i:hover {
    color: #409eff;
  }
}
.el-form-item {
  margin-bottom: 0px;
}
.date {
  margin-bottom: 10px;
}
.el-checkbox {
  width: 95%;
  text-align: right;
}
</style>
<style lang="less">
.all-select .el-select__tags-text {
  max-width: 62px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.all-select .el-tag__close {
  margin-bottom: 13px;
}
.report_select ul li:nth-child(2) {
  // margin-top: 2% !important;
}
</style>
